<!--
* UIID: UI-Caas-PTN-100
* UI Name: Parnert Card Detail
* Modify Date: 2020/06/17
-->
<template>
  <div>
    <v-card
      class="p-2 partner-card-container"
      :color="getStatusColor(item.stsCd)"
      :class="viewMode"
    >
      <v-row class="no-gutters">
        <v-col cols="2" class="pt-0">
          <v-avatar
            :color="getColorFromText(item.prnrNm)"
            size="20"
            class="font-extrabold font-avatar bg-blur"
          >
            {{ item.prnrNm.substring(0, 1) }}
          </v-avatar>
        </v-col>

        <v-col cols="10">
          <v-row class="no-gutters parnert-card-title">
            <v-col cols="11" class="text-sm">{{ item.prnrNm }}</v-col>

            <v-col cols="1" v-show="$auth.manage">
              <dropdownMenu
                :dataValue="item"
                :items="items"
                @click-event="onClickMenu($event)"
                @edit-event="onClickMenu($event)"
                @refresh="refresh()"
              />
            </v-col>
          </v-row>
          <v-row class="no-gutters">
            <v-col cols="12" class="font-bold text-sm">{{ item.cnttPrn }}</v-col>
          </v-row>
          <v-row class="no-gutters mb-6">
            <v-col cols="12">
              <v-row class="no-gutters">
                <v-col cols="11">
                  <a
                    :href="`mailto:${item.email}`"
                    color="#027DB2"
                    class="underline text-sm"
                  >{{ item.email }}</a>
                </v-col>
                <v-col cols="1">
                  <v-icon x-small>far fa-envelope</v-icon>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="no-gutters">
            <v-col
              cols="12"
              class="text-left text-sm font-semibold"
              :class="viewStatusTextColor(item.stsCd)"
            >{{ viewStatus(item.stsCd) }}</v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-card
      class="p-2 font-light partner-card-container"
      :color="getStatusColor(item.stsCd)"
      :class="editMode"
    >
      <v-form ref="form" lazy-validation autocomplete="off" class="partner-grid-form">
        <v-row class="custom-form-control ml-0 mr-0">
          <v-col cols="12" class="pa-0">
             <v-text-field
              v-model="item.prnrNm"
              :error-messages="formError.name.message"
              :placeholder="$t('lbl.partners.enterTheName')"
              ref="name"
              :autofocus="true"
              outlined
              :rules="[validationUtils.required, validationUtils.max(50)]"
              solo
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="custom-form-control ml-0 mr-0">
          <v-col cols="12" class="pa-0">
            <v-text-field
              v-model="item.cnttPrn"
              :error-messages="formError.name.message"
              :placeholder="$t('lbl.partners.contactPersonName')"
              ref="cnttPrn"
              outlined
              :rules="[validationUtils.required, validationUtils.max(100)]"
              solo
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="custom-form-control ml-0 mr-0">
          <v-col cols="4" class="pa-0">
            <v-text-field
              v-model="item.emailF"
              ref="emailF"
              :error-messages="formError.name.message"
              :placeholder="$t('lbl.partners.emailAddress')"
              outlined
              :rules="[validationUtils.required, validationUtils.max(45), v => /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*$/i.test(v) || 'Email Address Local-part must be valid']"
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="1" class="pa-0">@
          </v-col>
          <v-col cols="7" class="pa-0">
            <v-text-field
              v-model="item.emailT"
              ref="emailF"
              :error-messages="formError.name.message"
              :placeholder="$t('lbl.partners.emailAddress')"
              readonly
              outlined
              :rules="[validationUtils.required, validationUtils.max(45), v => /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*$/i.test(v) || 'Email Address Local-part must be valid']"
              solo
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="custom-form-control ml-0 mr-0">
          <v-col cols="12" class="pa-0">
            <v-text-field
              v-model="item.remark"
              ref="remark"
              :error-messages="formError.name.message"
              :placeholder="$t('lbl.partners.remark')"
              outlined
              :rules="[validationUtils.required, validationUtils.max(200)]"
              solo
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="custom-form-control ml-0 mr-0">
          <v-col cols="5" lg="4" md="4"  class="pt-0 pb-0 pl-0">
            <v-btn class="btn" text icon @click="cancelEdit()">
              <v-icon small>fa fa-times</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="7" lg="8" md="8" class="pt-0 pl-0 pb-0 pr-0">
            <div class="text-right">
              <v-btn class="btn btn-search btn-width-1" color="primary" @click="okEdit()">{{$t('btn.common.save')}}</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>


<script>
  import dropdownMenu from '@/vue-caas/views/partner/PartnerDropdownMenu.vue'

  export default {
    components: {
      dropdownMenu,
    },

    props: {
      detail: {
        default: Object,
      },
    },

    data(){
      return{
      item: {
        default: Object,
      },
      formError : {
        name : {
          message : ''
        }
      },
      view: true,
      edit: false,
      items: [
        { content: 'Edit...', code: "E" },
        { content: 'Delete this partner', code: "D"  },
      ],
      rules: {
        prnrNm: [
          v => !!v || 'Partner Name is required',
          v => !v || v.length <= 50 || 'Partner Name max length is 50.',
        ],
        cnttPrn: [
          v => !!v || 'Contact Person is required',
          v => !v || v.length <= 100 || 'Contact Person max length is 100.',
        ],
        emailF: [
          v => !!v || 'Partner Email Local-part is required',
          v => !v || v.length <= 45 || 'Company Email Local-part max length is 45.',
          v => /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*$/i.test(v) || 'Email Address Local-part must be valid',
        ],
        remark: [
          v => !v || v.length <= 200 || 'Remark max length is 200.',
        ],
      },
      formHasErrors: false,
    }},

    watch: {
      detail() {
        this.item = this.detail;
      }
    },

    computed: {
      viewMode() {
        return this.view?"":"d-none";
      },
      editMode() {
        return this.edit?"":"d-none";
      },
      form() {
        return {
          compNm: this.item.compNm,
          cnttPrn: this.item.cnttPrn,
          emailF: this.item.emailF,
          remark: this.item.remark,
        };
      },
    },

    methods: {
      initialize() {
        this.item = JSON.parse(JSON.stringify(this.detail));
      },
      setFieldValidation(name, message) {
        this.formError[name] = {
          message
        };
      },

      // avatar color
      // getColorFromText(text) {
      // getColorFromText() {
      //   // let colorCode = text.charCodeAt(0);
      //   // let colorNum = colorCode%13
      //   // let colorStr = "success";

      //   // if(colorNum == 0) {
      //   //   colorStr = "red";
      //   // } else if(colorNum == 1) {
      //   //   colorStr = "purple";
      //   // } else if(colorNum == 2) {
      //   //   colorStr = "deep-purple";
      //   // } else if(colorNum == 3) {
      //   //   colorStr = "indigo";
      //   // } else if(colorNum == 4) {
      //   //   colorStr = "blue";
      //   // } else if(colorNum == 5) {
      //   //   colorStr = "light-blue";
      //   // } else if(colorNum == 6) {
      //   //   colorStr = "cyan";
      //   // } else if(colorNum == 7) {
      //   //   colorStr = "teal";
      //   // } else if(colorNum == 8) {
      //   //   colorStr = "green";
      //   // } else if(colorNum == 9) {
      //   //   colorStr = "orange";
      //   // } else if(colorNum == 10) {
      //   //   colorStr = "deep-orange";
      //   // } else if(colorNum == 11) {
      //   //   colorStr = "brown";
      //   // } else if(colorNum == 12) {
      //   //   colorStr = "blue-grey";
      //   // }

      //   // return colorStr + " " + (this.$vuetify.theme.dark ? "darken-4" : "lighten-1");
      //   return '#8895AA';
      // },

      getColorFromText(text) {
        let colorCode = (text.charCodeAt(0) * text.charCodeAt(0) * text.charCodeAt(0) * text.charCodeAt(0) * 0xffffff).toString(16).substring(0, 6);
        // alert("text : " + text + "\ntext.charCodeAt(0) : " + text.charCodeAt(0) + "\ncolor code : " + colorCode);
        // alert((15).toString(16));
        return '#' + colorCode;
      },

      onClickMenu(item) {
        if(item.code == 'E') {
          this.view = false;
          this.edit = true;
        }
      },

      cancelEdit() {
        this.initialize();

        this.view = true;
        this.edit = false;
      },

      okEdit() {
        this.formHasErrors = false;

        Object.keys(this.item).forEach(key => {
          if (this.$refs.key !== undefined) {
            if (!this.formData.key || this.formData.key === '') this.formHasErrors = true;

            this.$refs.key.validate(true);
          }
        });

        if (!this.formHasErrors) {
          this.$store.dispatch('updatePartner', this.item).then(() => {
            this.refresh();
            this.view = true;
            this.edit = false;
          });
        }
      },

      refresh() {
        this.$emit('refresh');
      },

      viewStatus(stsCd) {
        let result = '';
        if (stsCd === 'C') {
          result = 'Confirmed';
        } else if (stsCd === 'W') {
          result = 'Waiting Confirmation';
        } else if (stsCd === 'N') {
          result = 'Not Send Email';
        }
        return result;
      },

      getStatusColor(stsCd) {
        let result = '';
        if(stsCd === 'C') {
          result = 'confirm darken-1'
        } else if(stsCd === 'W') {
          result = 'waiting darken-1';
        } else if (stsCd === 'N') {
          result = 'notsend darken-1';
        }
        return result;
      },

      viewStatusTextColor(stsCd) {
        let result = '';
        if (stsCd === 'C') {
          result = 'confirm--text text--lighten-1';
        } else if (stsCd === 'W') {
          result = 'waiting--text text--lighten-1';
        } else if (stsCd === 'N') {
          result = 'notsend--text text--lighten-1';
        }
        return result;
      }
    },

    created() {
      this.initialize();
    },

  }
</script>

<style>
  .partner-card-container{
     padding: 20px 15px 15px 15px !important;
   }
  .parnert-card-title{
    margin-bottom: 10px;
  }
  .partner-grid-form button{
     width: 100px;
  }
  .card-table-size{
    font-size:14px;
  }
  .partner-card-form{
    border:1px solid #5c5d6a;
    border-radius: 4px !important;
  }
  .partner-grid-form .custom-form-control .v-input__slot{
     padding: 0px !important;
     min-height: 30px !important;
  }
  /* Theme-light */
  .theme--light .partner-card-container{
   background: linear-gradient(to top right,transparent 50%,#ffffff 0) top right/25px 26px no-repeat,
   linear-gradient(to bottom left,transparent 50%,#ffffff 0) bottom left/25px 26px no-repeat, #ffffff;
  }
  .theme--light .partner-card-container .v-avatar{
    color : #FFFFFF;
  }
  .theme--light .partner-card-container .fa.fa.fa.fa-times{
    color: rgba(0, 0, 0, 0.54);
  }
  /* Theme-dark */
  .theme--dark .partner-card-container{
   background: linear-gradient(to top right,transparent 50%,#191a21 0) top right/25px 26px no-repeat,
   linear-gradient(to bottom left,transparent 50%,#191a21 0) bottom left/25px 26px no-repeat, #191a21;
  }
  .theme--dark .v-icon.notranslate.far.fa-envelope{
    color: inherit;
  }
  .theme--dark .partner-grid-form .v-text-field--solo .v-input__control .v-input__slot{
    background-color: inherit;
    border-radius: 4px;
  }
  .theme--dark .partner-grid-form .v-text-field--solo .v-input__control .v-input__slot input{
    font-size:14px;
    border-radius: 4px;
    background:inherit;
  }
  .theme--dark .partner-grid-form .custom-form-control{
    background: inherit;
    margin-bottom: 5px;
  }
  .theme--dark .partner-grid-form .custom-form-control .v-input__slot{
     padding: 0px !important;
     min-height: 30px !important;
     background-color: inherit !important;
  }
</style>